import React, {useMemo} from "react";
import {Box, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {routeFunctions} from "../../../../../core/models/static/routes/app-routes";
import {DuplicateOrderVariants} from "../index";
import {ReactComponent as SuccessSvg} from "../../../../../assets/images/art-like/quick-order-submitted.svg";

const DuplicateOrderDialogReviewResultsSection = ({createdOrderDetails}) => {
    const {id, type, targetCustomerId} = createdOrderDetails ?? {};

    const [title, orderLink] = useMemo(() => ([
        type === DuplicateOrderVariants.Quotes ? "Quote" : "Sales Order",
        type === DuplicateOrderVariants.Quotes ? routeFunctions.customer.sales.quotes.single(targetCustomerId, id) : routeFunctions.customer.sales.salesOrder.single(targetCustomerId, id),
    ]), [id, targetCustomerId, type]);

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', minHeight: 180, gap: 2, marginBlock: 4}}>
                <SuccessSvg width={'300px'}/>
                <Typography variant="h6" fontWeight={600}>
                    Success!
                </Typography>
                <Typography variant="body1">
                    The {title} has been successfully created and the requested information was duplicated.
                </Typography>
                {
                    !!orderLink &&
                    <Link to={orderLink} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
                        <Typography
                            variant="body1"
                            color="primary"
                            fontWeight={600}
                            sx={{textDecoration: 'underline', '&:hover': {color: 'primary.dark'}}}
                        >
                            Click here to open the new {title} in a new tab.
                        </Typography>
                    </Link>
                }
            </Box>
        </>
    );
};

export default DuplicateOrderDialogReviewResultsSection;
